function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.929 14a.885.885 0 00.643-.266l5.09-4.985c.225-.227.331-.46.338-.746 0-.286-.106-.525-.338-.745l-5.09-4.992A.896.896 0 009.93 2 .923.923 0 009 2.925c0 .253.106.493.292.679l4.512 4.4-4.512 4.392a.961.961 0 00-.292.679c0 .512.411.925.929.925z"
});

function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-element": "icon",
    className: "icon_cbe9250 Tae4HHS0E3abJ2erVV9Km",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.52899046.svg";
export { ForwardRef as ReactComponent };